import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { OpportunitiesGridComponent } from "./opportunities-grid/opportunities-grid.component";

const routes: Routes = [
    { path: '', component: OpportunitiesGridComponent },
    // {
    //     path: ':id',
    //     component: CreateEditItemConfigGridComponent,
    //     canActivate: [DialogGuard],
    //     data: { component: CreateEditItemConfigGridComponent },
    // },
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class OpportunitiesRoutingModule { }